exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".script-list{margin-top:var(--navbar-height)}.script-tile-list{list-style:none;display:grid;grid-template-columns:repeat(var(--script-list-column-count),1fr);row-gap:var(--script-list-row-gap);-moz-column-gap:var(--script-list-col-gap);column-gap:var(--script-list-col-gap)}.script-list-title,.script-list>li{display:block}", ""]);

// exports
